import { useCallback, useMemo, useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { useGetMdtAssessmentListQuery } from "store/services/mdt/assessment";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import moment from "moment";
import { formatString, getAge, userFullName } from "helpers/common";
// import { useTherapistLookupQuery } from "store/services/utility";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { CommonSelect, CstmPagination } from "components/Common/Common";
import TableLayout from "components/TableLayout";
import { CLIENT_TYPES, SPECIALIZATION_OPTIONS } from "config/constants";
import DatePicker from "react-datepicker";
import { useGetMdtStatusListQuery } from "store/services/utility";
import { CalendarIcon } from "Assets/icons";
import TableLayoutV2 from "components/TableLayoutV2";
import { debounce } from "lodash";

const Multidisciplinary = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filter, setFilter] = useState({ search: "", client_type: "", specialization: "", mdtStatus: "", startDate: "", endDate: "", status: "", sort: { column: "id", direction: "desc" } });

  const { data, isLoading, isError, isFetching } = useGetMdtAssessmentListQuery({ page: currentPage, limit: pageSize, ...filter });
  const assessmentList = data?.records;
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  // status list
  const { data: mdtStatusList, isFetching: statusListLoading } = useGetMdtStatusListQuery();
  const statusList = mdtStatusList?.length && mdtStatusList?.filter(status => status?.is_default === "yes");
  const statusOptions = statusList?.length > 0 ? statusList?.map((item) => ({ label: item?.title, value: item?.id })) : []
  // Practitioner specialization options
  const specializationOptions = useMemo(() => ([
    ...Object.entries(SPECIALIZATION_OPTIONS).map(([key, label]) => ({ value: key, label }))
  ]), []);

  const column = [
    {
      head: "Last Name",
      accessor: "lastname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item.lastname}</h6>
      ),
    },
    {
      head: "First Name",
      accessor: "firstname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item.firstname}</h6>
      ),
    },
    {
      head: "DOB",
      accessor: "DOB",
      isComponent: true,
      component: (item, ind) => (
        <>{item?.client_detail?.dob ? moment(item?.client_detail?.dob).format("DD/MM/YYYY") : "--"}</>
      ),
    },
    {
      head: "Age",
      accessor: "Age",
      isComponent: true,
      component: (item, ind) => (
        <>{item?.client_detail?.dob ? getAge(item?.client_detail?.dob) : "--"}</>
      ),
    },
    {
      head: "Client Type",
      accessor: "ClientCategory",
      isComponent: true,
      component: (item, ind) => (
        <>{item?.client_detail?.client_type ? formatString(item?.client_detail?.client_type) || "--" : "--"}</>
      ),
    },
    {
      head: "Team Lead",
      accessor: "TeamLead",
      isComponent: true,
      component: (item, ind) => (
        <>{item?.client_detail?.clientMdtDetail?.clientMdtTeamLead ? userFullName(item?.client_detail?.clientMdtDetail?.clientMdtTeamLead) : "--"}</>
      )
    },
    {
      head: "Clinic Date",
      accessor: "ClinicDate",
      isComponent: true,
      component: (item, ind) => (
        <>{item?.client_detail?.clientMdtDetail?.clinic_date ? moment(item?.client_detail?.clientMdtDetail?.clinic_date).format("DD/MM/YYYY") : "--"}</>
      ),
    },
    {
      head: "Status",
      accessor: "Status",
      isComponent: true,
      component: (item, ind) => {
        const status = item?.clientPendingCaseload?.mdtCaseloadStatus?.title
        return (
          // <p
          //   style={{ maxWidth: "max-content" }}
          //   className={`${status == "active"
          //     ? "greenStatus"
          //     : status == "inactive"
          //       ? "redStatus"
          //       : status == "pending"
          //         ? "yellowStatus"
          //         : "yellowStatus"
          //     } status text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
          // >
          //   <span className="icn me-2">
          //     <svg
          //       xmlns="http://www.w3.org/2000/svg"
          //       width="7"
          //       height="7"
          //       viewBox="0 0 7 7"
          //       fill="none"
          //     >
          //       <circle cx="3.5" cy="3.5" r="3.5" fill="currentColor" />
          //     </svg>
          //   </span>
          //   {status}
          // </p>
             <div style={{ color: status == "Active" && '#55A215', fontStyle: !["Active"]?.includes(status) && "italic" }} className="text-capitalize">
          {(status || "--")}
        </div>
        )
      },
    },
    // {
    //   head: "Action",
    //   accessor: "",
    //   isComponent: true,
    //   component: (item) => (
    //     <div className="ActnBtn d-flex align-items-center  gap-10">
    //       <CommonToolTip
    //         text={"Delete"}
    //         component={<Button
    //           className="p-0"
    //           variant="transparent"
    //           type="button"
    //           onClick={(e) => {

    //             e.stopPropagation();
    //             setCurrentItem(item);
    //             setShowModal(true);
    //           }}
    //         >
    //           <DeleteIcon />
    //         </Button>}
    //       />
    //     </div>
    //   ),
    // },
  ];

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const resetFilter = () => {
    setFilter({
      search: "",
      specialization: "",
      status: ""
    });
    setCurrentPage(1)
  };

  const handleSearchChange = useCallback(debounce((value) => {

    handleFilterChange("search")(value);

  }, 500), [handleFilterChange, 500]);

  return (
    <>
      {/* <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handleDelete}
        type="delete"
      /> */}
      <section className="client position-relative py-4">
        <Container fluid={true}>
          <Row>
              <div className="left classroom-conslutation">
                <h6 className="m-0 fw-bold main-head themeBlue">Multidisciplinary Assessment</h6>
              </div>
            <Col lg="12" className="my-2">
              <Row className="reports-v2 my-3 gap-2 gap-lg-0 d-flex justify-content-end classroom-conslutation">
                <Col md='3' lg="2">
                  <div className="w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Practitioner</label>
                    <CommonSelect
                      placeholder={"Select"}
                      option={specializationOptions || []}
                      onChange={(e) => handleFilterChange("specialization")(e)}
                      value={filter?.specialization}
                      // onInputChange={(val) => handleSearch(val)}
                      isFilterV2
                      isClearable
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                    // isLoading={schoolsLoading}
                    />
                  </div>
                </Col>
                <Col md='2'>
                  <div className="w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">MDT Status</label>
                    <CommonSelect
                      placeholder={"Choose one"}
                      option={statusOptions || []}
                      onChange={(e) => handleFilterChange("mdtStatus")(e)}
                      value={filter?.mdtStatus}
                      isFilterV2
                      isClearable
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                      isLoading={statusListLoading}
                    />
                  </div>
                </Col>
                <Col md='3' lg="2">
                  <div className="w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Client Type</label>
                    <CommonSelect
                      placeholder={"Select"}
                      option={CLIENT_TYPES}
                      onChange={(e) => handleFilterChange("client_type")(e)}
                      value={filter?.client_type}
                      isFilterV2
                      isClearable
                      // isLoading={schoolListLoading || schoolListFetching}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                    />
                  </div>
                </Col>
                <Col lg="2">
                <div className="w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Start Date</label>
                  <DatePicker
                    className={`input-new readonly-box h-auto search-input-filter-v2`}
                    placeholderText="Start Date"
                    selectsStart
                    icon={<CalendarIcon />}
                    showIcon
                    selected={filter?.startDate}
                    onChange={(e) => {
                      console.log(e);
                      handleFilterChange("startDate")(e)
                    }}
                  />
                  </div>
                  </Col>
                <Col lg="2">
                  <div className="w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">End Date</label>
                  <DatePicker
                    className={`input-new readonly-box h-auto search-input-filter-v2`}
                    placeholderText="End Date"
                    selectsEnd
                    icon={<CalendarIcon />}
                    showIcon
                    selected={filter?.endDate}
                    onChange={(e) => handleFilterChange("endDate")(e)}
                  />
                  </div>
                </Col>
                <Col lg="2">
                  <div className="w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Search</label>
                    <input
                      onChange={(e) => handleSearchChange(e.target.value)}
                      className={` readonly-box h-auto search-input-filter-v2`}
                      placeholder="Type..."
                      defaultValue={filter?.search}
                    />
                  </div>
                </Col>
              </Row>
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  {/* <TableHeader
                    heading={"Multidisciplinary Assessment"}
                    handleFilterChange={handleFilterChange}
                    resetFilter={resetFilter}
                    filter={filter}
                    searchPlaceholder="First Name, Last Name"
                    filterComponent={
                      <>
                        <li className="">
                          <Dropdown onSelect={handleFilterChange("specialization")}>
                            <Dropdown.Toggle
                              variant="transparent"
                              className="border-0 d-flex align-items-center  justify-content-center"
                              id="dropdown-basic"
                            >
                              {specializationOptions?.find(x => x.value == filter?.specialization)?.label || "Practitioner"}
                              <span className="icn ms-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="8"
                                  viewBox="0 0 12 8"
                                  fill="none"
                                >
                                  <path
                                    d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                    fill="black"
                                  />
                                </svg>
                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu >
                              {
                                !specializationOptions?.length ? (
                                  <Dropdown.Item disabled eventKey={null}>No Record Found</Dropdown.Item>
                                ) : specializationOptions?.map((item, index) => {
                                  return <Dropdown.Item key={index} eventKey={item.value}>{item.label}</Dropdown.Item>
                                })
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                        <li className="">
                          <Dropdown onSelect={handleFilterChange("mdtStatus")}>
                            <Dropdown.Toggle
                              variant="transparent"
                              className="border-0 d-flex align-items-center  justify-content-center"
                              id="dropdown-basic"
                            >
                              {statusList?.find(x => x.id == filter?.mdtStatus)?.title || "MDT Status"}
                              <span className="icn ms-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="8"
                                  viewBox="0 0 12 8"
                                  fill="none"
                                >
                                  <path
                                    d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                    fill="black"
                                  />
                                </svg>
                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu >
                              {
                                !statusList?.length ? <Dropdown.Item disabled eventKey={null}>No Record Found</Dropdown.Item> : statusList?.map((item, index) => {
                                  return <Dropdown.Item key={index} eventKey={item.id}>{item?.title}</Dropdown.Item>
                                })
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                        <li className="">
                          <Dropdown onSelect={handleFilterChange("client_type")}>
                            <Dropdown.Toggle
                              variant="transparent"
                              className="border-0 d-flex align-items-center  justify-content-center"
                              id="dropdown-basic"
                            >
                              {CLIENT_TYPES?.find(x => x.value == filter?.client_type)?.label || "Client Type"}
                              <span className="icn ms-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="8"
                                  viewBox="0 0 12 8"
                                  fill="none"
                                >
                                  <path
                                    d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                    fill="black"
                                  />
                                </svg>
                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu >
                              {
                                [{ label: "All", value: "" }, ...CLIENT_TYPES]?.map((item, index) => {
                                  return <Dropdown.Item key={index} eventKey={item.value}>{item?.label}</Dropdown.Item>
                                })
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                        <li>
                          <DatePicker
                            className="form-control filter-datepicker"
                            placeholderText="Start Date"
                            selectsStart
                            icon={<CalendarIcon />}
                            showIcon
                            selected={filter?.startDate}
                            onChange={(e) => {
                              console.log(e);
                              handleFilterChange("startDate")(e)
                            }}
                          />
                        </li>
                        <li>
                          <DatePicker
                            className="form-control filter-datepicker"
                            placeholderText="End Date"
                            selectsEnd
                            icon={<CalendarIcon />}
                            showIcon
                            selected={filter?.endDate}
                            onChange={(e) => handleFilterChange("endDate")(e)}
                          />
                        </li>
                      </>
                    }
                  /> */}
                </div>
              </div>
              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching) && <LoadingOverlay />}
                    <TableLayoutV2
                      data={assessmentList}
                      column={column}
                      url={"/multidisciplinary-services/detail"}
                      filter={filter}
                      handleSort={handleFilterChange("sort")}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  className='paginationV2'
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Multidisciplinary;
